import React from 'react';
import 'url-search-params-polyfill';
import {connect} from 'react-redux';
import accountManagement from '../../../../../../apis/accountManagement';
import { CONFIG } from '../../../../../../config';
import KelasParalelSearch from '../../../../../../entity/KelasParalelSearch';
import cbtManagement from '../../../../../../apis/cbtManagement';
import ProfilCbtSearch from '../../../../../../entity/ProfilCbtSearch';
import Loader from '../../../../../Loader';
import ProfilCbtOverview from '../ProfilCbtOverview';

import KelasSearch from '../../../../../../entity/KelasSearch';
import __ from 'lodash';
import TahunAjaranSearch from '../../../../../../entity/TahunAjaranSearch';
import PencapaianIndikator from './PencapaianIndikator';
class DetailCbtReport extends React.Component{

    state = {
        kelasParalel: [],
        profilCbt: {},
        sekolah: {},
        idKelas: null,
        idKelasParalelSelected: null,
        kodeTahunAjaranSelected: null,
        kodeTahunAjaranSelected: null,
        idProfilCbt: null,
        isLoadingProfil: false,
        kelas: [],
        tahunAjaran: [],
        subProfil: [],
        isLoadingOverview: false,
        idSiswaSelected: null
    }

    componentDidMount(){
        this.setIdProfil();
        this.fetchListTahunAjaran();
    }

    setIdProfil = async () =>{
        const urlParam = new URLSearchParams(window.location.search);
        this.setState({
            idProfilCbt: urlParam.get("idProfil")
        })
    }

    fetchListTahunAjaran = async () => {
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN,
            {...TahunAjaranSearch}).catch(function(error){

        })
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    tahunAjaran: response.data.data
                })
            }
        }
    }

    fetchKelasParalel = async () => {
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL,
            {...KelasParalelSearch, 
                ["idSekolah"]: this.props.account.idSekolah,
                ["idKelas"]: this.state.idKelas
            }).catch(function(error){

            });
            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        kelasParalel: response.data.data
                    })
                }
            }
    }

    fetchProfil = async () => {
        this.setState({
            isLoadingProfil: true
        })
        const response = await cbtManagement.post(CONFIG.CBT_MANAGEMENT_PROFIL_GET_BY_ID, 
            {...ProfilCbtSearch, 
            ["idProfilCbt"]: this.state.idProfilCbt,
            ["idSekolah"]: this.props.account.idSekolah,
            ["idKelasParalel"]: parseInt(this.state.idKelasParalelSelected),
            ["kodeTahunAjaran"]: this.state.kodeTahunAjaranSelected
        }).catch(function(error){

        })
        if(response){
            if(response.data !== null){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        profilCbt: response.data.data,
                        idKelas: response.data.data.idKelas
                    })
                }
            }
        }
        this.setState({
            isLoadingProfil: false
        })
    }

    fetchKelas = async () =>{
        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){

        })
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {...KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah}).catch(function(error){

        });
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
        this.fetchKelasParalel();
    }

    componentDidUpdate(prevProps, prevStates){
        /*
        if(prevProps.account !== this.props.account){
            console.log(this.props);
            if(this.state.idProfilCbt !== null){
                this.fetchProfil();
            }
        }
        */
       if(__.isEmpty(prevProps.account) && !__.isEmpty(this.props.account)){
            console.log(this.props.account);
            this.fetchKelas();
            if(__.isEmpty(this.state.profilCbt)){
                this.fetchProfil();
            }
        }
        if(prevStates.idProfilCbt !== this.state.idProfilCbt && !__.isEmpty(this.props.account)){
            this.fetchKelas();
            if(__.isEmpty(this.state.profilCbt)){
                this.fetchProfil();
            }
        }
        
        /*
        if(prevStates.idKelas !== this.state.idKelas){
            this.fetchKelasParalel();
        }
        */
    }

    renderProfilOVerview = () => {
        
        if(this.state.isLoadingProfil){
            return (
                <div>
                    <div className="card">
                        <div className="card-body">
                            <Loader />
                        </div>
                    </div>
                </div>
            )
        }else{
            if(!__.isEmpty(this.state.profilCbt)){
                return (
                    <div>
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="d-flex w-100 justify-content-between">
                                            <h5 className="mb-1">{this.state.profilCbt.namaProfil}</h5>
                                        </div>
                                        <small>{this.getKelas(this.state.profilCbt.idKelas)} <br />{this.state.profilCbt.jumlahPeserta} Peserta</small>
                                        <br/>
                                        <br/>
                                        <div className="row">
                                            <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                                <div className="progress">
                                                    <div className="progress-bar" role="progressbar" style={{width: "100%"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">Rata-rata nilai</div>
                                                </div>
                                                <br/>
                                                <div className="progress">
                                                    <div className="progress-bar bg-success" role="progressbar" style={{width: "100%"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">Siswa selesai</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <ProfilCbtOverview 
                                        isLoadingOverview={this.isLoadingOverview} 
                                        callbackFromParent={this.getSubProfilFromOverview} 
                                        showButton={false} 
                                        totalPeserta={this.state.profilCbt.jumlahPeserta} 
                                        idProfil={this.state.idProfilCbt} 
                                        idSekolah={this.props.account.idSekolah}
                                        idKelasParalel={this.state.idKelasParalelSelected}
                                        kodeTahunAjaran={this.state.kodeTahunAjaranSelected }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
        
    }

    getKelas(idKelas){
        for (var i = 0; i < this.state.kelas.length; i++) {
            if(idKelas === this.state.kelas[i].idKelas){
                return this.state.kelas[i].namaKelas;
            }
        }
    }

    renderDropdownKelasParalel = () => {
        if(!__.isEmpty(this.state.kelasParalel)){
            return this.state.kelasParalel.map((par) => {
                return (
                <option value={par.idKelasParalel}>{par.namaKelasParalel}</option>
                )
            })
        }
    }

    onSelectKelasParalel = (event) => {
        if(event.target.value === ""){
            this.setState({
                idKelasParalelSelected: null
            })
        }else{
            this.setState({
                idKelasParalelSelected: event.target.value
            })
        }
    }

    onSelectTahunAjaran = (event) => {
        if(event.target.value === ""){
            this.setState({
                kodeTahunAjaranSelected: null
            })
        }else{
            this.setState({
                kodeTahunAjaranSelected: event.target.value
            })
        }
    }

    renderDropDownTahunAjaran = () => {
        if(!__.isEmpty(this.state.tahunAjaran)){
            return this.state.tahunAjaran.map((ta) => {
                return(
                    <option value={ta.kodeTahunAjaran}>{ta.kodeTahunAjaran}</option>
                )
            })
        }
    }

    getSubProfilFromOverview = (dataFromOverview) => {
        this.setState({
            subProfil: dataFromOverview
        })
    }

    isLoadingOverview = (isLoadingOverview) => {
        this.setState({
            isLoadingOverview: isLoadingOverview
        })
    }

    renderAccordionIndikator = () => {
        if(this.state.isLoadingOverview){
            return (
                <div>
                    <Loader />
                </div>
            )
        }else{
            if(!__.isEmpty(this.state.subProfil)){
                return this.state.subProfil.map((sub) => {
                    const collapseIdTag = "#collapse" + sub.idSubProfilCbt;
                    const collapseId = "collapse" + sub.idSubProfilCbt;
                    const headingId = "heading" + sub.idSubProfilCbt;
                    return(
                        <div className="card">
                            <div className="card-header" id={headingId}>
                        <h2 className="mb-0">
                            <button className="btn btn-link" type="button" data-toggle="collapse" data-target={collapseIdTag} aria-expanded="true" aria-controls={collapseId}>
                            {sub.namaMataPelajaran}
                            </button>
                        </h2>
                        </div>

                        <div id={collapseId} className="collapse show" aria-labelledby={headingId} data-parent="#accordionExample">
                        <div className="card-body">
                            <PencapaianIndikator 
                            idSekolah={this.props.account.idSekolah} 
                            idProfil={this.state.profilCbt.idProfil} 
                            idSubProfil={sub.idSubProfilCbt}
                            idSiswa={this.state.idSiswaSelected}
                            idKelasParalel={this.state.idKelasParalelSelected}
                            kodeTahunAjaran={this.state.kodeTahunAjaranSelected}
                            />
                        </div>
                        </div>
                    </div>
                    )
                })
            }
        }
    }

    render(){
        return(
            <div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <select className="form-control" onChange={this.onSelectTahunAjaran}>
                            <option value="">Semua Tahun Ajaran</option>
                            {this.renderDropDownTahunAjaran()}
                        </select>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <select className="form-control" onChange={this.onSelectKelasParalel}>
                            <option value="">Semua Kelas Paralel</option>
                            {this.renderDropdownKelasParalel()}
                        </select>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <button className="btn btn-primary" onClick={this.fetchProfil}>
                            Filter
                        </button>
                    </div>
                    <div className="col-12">
                        <br/>
                    </div>
                    <div className="col-md-12 col-lg-12">
                        {this.renderProfilOVerview()}
                    </div>
                    <div className="col-md-12 col-lg-12">
                        <div className="accordion" id="accordionExample">
                            {this.renderAccordionIndikator()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return{
        account: state.account
    };
}
export default connect(mapStateToProps)(DetailCbtReport);